document.addEventListener('DOMContentLoaded', function() {
    const initialImageElement = document.querySelector('.product-gallery__media.snap-center.is-initial img');
    const initialImageUrl = initialImageElement ? initialImageElement.src : '';

    const roseGoldImageUrl = document.getElementById('roseGoldImageUrl').innerText;
    const whiteGoldImageUrl = document.getElementById('whiteGoldImageUrl').innerText;

    document.querySelectorAll('[name="properties[Gold Color]"]').forEach(function(radio) {
        radio.addEventListener('change', function(e) {
            if (e.target.checked) {
                updateProductImage(e.target.dataset.metafieldKey, initialImageUrl, roseGoldImageUrl, whiteGoldImageUrl);
            }
        });
    });
});

function updateProductImage(metafieldKey, initialImageUrl, roseGoldImageUrl, whiteGoldImageUrl) {
    const imageUrl = getProductImageUrl(metafieldKey, initialImageUrl, roseGoldImageUrl, whiteGoldImageUrl);
    const imageContainer = document.querySelector('.product-gallery__media.snap-center.is-initial img');
    if (imageContainer) {
        imageContainer.src = imageUrl;
        // Temporarily remove the srcset to isolate the issue
        imageContainer.removeAttribute('srcset');
    }
}

function getProductImageUrl(key, initialImageUrl, roseGoldImageUrl, whiteGoldImageUrl) {
    switch (key) {
        case 'yellow_gold_image':
            return initialImageUrl;
        case 'rose_gold_image':
            return roseGoldImageUrl;
        case 'white_gold_image':
            return whiteGoldImageUrl;
        default:
            return initialImageUrl;
    }
}
